import request from '@/utils/request'

// 获取课程列表（第一行tab）
export function getSubjects(gradeId) {
  return request({
    url: '/front/course/subjects',
    method: 'get',
    params: { gradeId }
  })
}

// 获取科目列表（第二行tab）
export function getCourses(subjectId) {
  return request({
    url: '/front/course/courses',
    method: 'get',
    params: { subjectId }
  })
}

// 获取章列表（第三行tab）
export function getChapters(courseId, mode) {
  return request({
    url: '/front/course/chapters',
    method: 'get',
    params: { courseId, mode }
  })
}

// 获取节列表（卡片区域）
export function getSections(chapterId, mode) {
  return request({
    url: '/front/course/sections',
    method: 'get',
    params: { chapterId, mode }
  })
}

// 获取模式进度
export function getModeProgress(mode, courseId) {
  return request({
    url: '/front/course/progress',
    method: 'get',
    params: { mode, courseId }
  })
}
